module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('t-select', {
    ref: "select",
    attrs: {
      "disabled": _vm.disabled,
      "placeholder": _vm.placeholder,
      "size": _vm.size,
      "placement": _vm.placement,
      "remote-method": _vm.$_remoteMethod,
      "filterable": "",
      "remote": "",
      "auto-complete": ""
    },
    on: {
      "on-change": _vm.$_handleChange
    }
  }, [_vm._t("input", [_c('t-input', {
    ref: "input",
    attrs: {
      "slot": "input",
      "placeholder": _vm.placeholder,
      "disabled": _vm.disabled,
      "size": _vm.size,
      "icon": _vm.icon,
      "icon-placement": _vm.iconPlacement
    },
    on: {
      "on-focus": _vm.$_handleFocus,
      "on-blur": _vm.$_handleBlur
    },
    slot: "input",
    model: {
      value: (_vm.currentValue),
      callback: function($$v) {
        _vm.currentValue = $$v
      },
      expression: "currentValue"
    }
  })]), _vm._v(" "), _vm._t("default", _vm._l((_vm.filteredData), function(item) {
    return _c('t-option', {
      key: item,
      attrs: {
        "value": item
      }
    }, [_vm._v(_vm._s(item))])
  }))], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-03c4ea1a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/auto-complete/auto-complete.vue
// module id = 337
// module chunks = 0